import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Card from '@/components/ui/Card'
import { Clock } from 'lucide-react'

interface PrayerCountdownProps {
  nextPrayerTime: string // Format: "HH:mm"
  prayerName: string // already translated
}

export default function PrayerCountdown({ nextPrayerTime, prayerName }: PrayerCountdownProps) {
  const { t } = useTranslation()
  const [timeRemaining, setTimeRemaining] = useState('')

  useEffect(() => {
    const calculateTimeRemaining = () => {
      const now = new Date()
      const [hours, minutes] = nextPrayerTime.split(':').map(Number)
      const prayerTime = new Date()
      prayerTime.setHours(hours, minutes, 0, 0)

      if (prayerTime < now) {
        prayerTime.setDate(prayerTime.getDate() + 1)
      }

      const diff = prayerTime.getTime() - now.getTime()
      const hoursRemaining = Math.floor(diff / (1000 * 60 * 60))
      const minutesRemaining = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))

      if (hoursRemaining > 0) {
        setTimeRemaining(t('prayer.inHoursMinutes', { hours: hoursRemaining, minutes: minutesRemaining }))
      } else if (minutesRemaining > 0) {
        setTimeRemaining(t('prayer.inMinutesOnly', { minutes: minutesRemaining }))
      } else {
        setTimeRemaining(t('prayer.now'))
      }
    }

    calculateTimeRemaining()
    const interval = setInterval(calculateTimeRemaining, 60000)

    return () => clearInterval(interval)
  }, [nextPrayerTime, t])

  return (
    <Card className="bg-gradient-to-br from-primary-600 to-primary-700 dark:from-primary-700 dark:to-primary-800 text-white transition-colors">
      <div className="flex items-center gap-3 mb-4">
        <Clock className="w-6 h-6" />
        <h3 className="text-xl font-bold">{t('prayer.nextPrayerTitle', { name: prayerName })}</h3>
      </div>
      <p className="text-3xl font-bold mb-2">{nextPrayerTime}</p>
      <p className="text-primary-100 dark:text-primary-200">{timeRemaining}</p>
    </Card>
  )
}

